import { render } from "./PrescriptionsPage.vue?vue&type=template&id=0c735def&ts=true"
import script from "./PrescriptionsPage.vue?vue&type=script&lang=ts"
export * from "./PrescriptionsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__